import { loginApi, logoutApi, getUserInfoApi } from "@/api/user";
import { message } from "ant-design-vue";
export default {
  namespaced: true,
  state: {
    pcLoginPop: false,
    h5LoginPop: false,
    userInfo: null,
    phone: "",
  },
  getters: {
    getPcLoginPop: (state) => state.pcLoginPop,
    getH5LoginPop: (state) => state.h5LoginPop,
    getUserInfo: (state) => state.userInfo,
  },
  mutations: {
    setPcLoginPop(state, payload) {
      state.pcLoginPop = payload;
    },
    setH5LoginPop(state, payload) {
      state.h5LoginPop = payload;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
  },
  actions: {
    async login(_, params) {
      try {
        const res = await loginApi(params);
        const { token } = res;
        localStorage.setItem("token", token);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    doLogout({ commit }) {
      commit("setUserInfo", null);
    },
    async logout({ commit }) {
      try {
        await logoutApi();
        localStorage.clear();
        commit("setUserInfo", null);
        message.success("已退出登录！");
      } catch (err) {
        console.log(err);
        message.warning("退出失败！请稍后重试");
      }
    },
    async getUserInfoAction({ commit }) {
      try {
        const { results } = await getUserInfoApi();
        console.log(results);
        commit("setUserInfo", results);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
